import React, { useState } from 'react'
import { CCard, CCardHeader, CForm, CFormInput, CButton } from 'compat/coreui';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { IMAGE_URL } from '../Constants/constants';

// Storefront catalog for one seller: product grid + mini cart.
export default function BusinessMenu({ seller }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const items = useSelector(state => state.products)
	const [search, setSearch] = useState('');

	const persist = (arr) => {
		dispatch({ type: 'UPDATE_PRODUCT', data: arr });
		if (arr.length === 0) localStorage.removeItem('myProduct');
		else localStorage.setItem('myProduct', JSON.stringify(arr));
	};

	const addToCart = (product) => {
		if (product.stock !== null && product.stock !== undefined && product.stock <= 0) {
			toast.warn('Out of stock');
			return;
		}
		const arr = items.slice();
		const found = arr.find(e => String(e.productId) === String(product._id));
		if (found) {
			found.quantity = (parseInt(found.quantity, 10) || 1) + 1;
		} else {
			arr.push({ productId: product._id, quantity: 1, productDetails: product });
		}
		persist(arr);
		toast.success(`${product.name} added to cart`);
	};

	const removeItem = (index) => {
		const arr = items.slice();
		arr.splice(index, 1);
		persist(arr);
	};

	const cartTotal = items.reduce((sum, item) =>
		sum + (parseFloat(item.productDetails && item.productDetails.price) || 0) * (parseInt(item.quantity, 10) || 1), 0);

	const products = (seller && seller.products) || [];
	const menus = (seller && seller.menus) || [];
	const matches = (p) => !search ||
		(p.name || '').toLowerCase().includes(search.toLowerCase()) ||
		(p.brand || '').toLowerCase().includes(search.toLowerCase());

	const productCard = (product) => {
		const out = product.stock !== null && product.stock !== undefined && product.stock <= 0;
		return (
			<div className="bp-product-card" key={product._id}>
				<div className="bp-product-img">
					<img alt={product.name} src={product.image ? IMAGE_URL + product.image : '/images/placeholder.svg'} />
					{out && <span className="bp-product-out">Out of stock</span>}
					{!out && product.stock !== null && product.stock !== undefined && product.stock < 10 &&
						<span className="bp-product-low">Only {product.stock} left</span>}
				</div>
				<div className="bp-product-info">
					{product.brand && <span className="bp-product-brand">{product.brand}</span>}
					<h4>{product.name}</h4>
					<p>{product.description}</p>
					<div className="bp-product-footer">
						<span className="bp-product-price">${product.price}</span>
						<button className="bp-btn-primary bp-product-add" disabled={out} onClick={() => addToCart(product)}>
							{out ? 'Unavailable' : 'Add to Cart'}
						</button>
					</div>
				</div>
			</div>
		);
	};

	return (
		<div>
			<div className="bp-panel">
				<CCardHeader className="category_header">
					<span style={{ fontSize: "18px" }}>Products</span>
					<div>
						<CForm inline onSubmit={e => e.preventDefault()}>
							<CFormInput
								className="mr-sm-2"
								placeholder="Search products…"
								size="sm"
								value={search}
								onChange={e => setSearch(e.target.value)}
							/>
						</CForm>
						<Link to="/cart"><span>Go To Cart</span></Link>
					</div>
				</CCardHeader>

				{menus.length === 0 && products.filter(matches).length === 0 && (
					<p className="text-center p-5 bp-dim">This shop hasn't listed any products yet.</p>
				)}

				{menus.map((menu) => {
					const menuProducts = products.filter(p => p.category === menu._id).filter(matches);
					if (!menuProducts.length) return null;
					return (
						<div key={menu._id} className="bp-catalog-section">
							<h2>{menu.title}</h2>
							<div className="bp-product-grid">
								{menuProducts.map(productCard)}
							</div>
						</div>
					);
				})}
				{/* products whose category isn't in menus still render */}
				{(() => {
					const menuIds = new Set(menus.map(m => String(m._id)));
					const orphans = products.filter(p => !menuIds.has(String(p.category))).filter(matches);
					if (!orphans.length) return null;
					return (
						<div className="bp-catalog-section">
							<div className="bp-product-grid">{orphans.map(productCard)}</div>
						</div>
					);
				})()}
			</div>

			{items.length > 0 && (
				<div className="bp-minicart">
					<div className="bp-minicart-head">
						<h4>Your Cart</h4>
						<span className="bp-mono">{items.length} item{items.length > 1 ? 's' : ''}</span>
					</div>
					{items.map((item, index) => (
						<div className="bp-minicart-line" key={index}>
							<span className="bp-minicart-name">{item.productDetails ? item.productDetails.name : ''}</span>
							<span className="bp-mono">×{item.quantity}</span>
							<span className="bp-mono">${((parseFloat(item.productDetails && item.productDetails.price) || 0) * (parseInt(item.quantity, 10) || 1)).toFixed(2)}</span>
							<button className="bp-cart-remove" onClick={() => removeItem(index)} aria-label="Remove">✕</button>
						</div>
					))}
					<div className="bp-minicart-total">
						<span>Total</span>
						<span className="bp-mono">${cartTotal.toFixed(2)}</span>
					</div>
					<CButton className="bp-btn-primary bp-checkout-btn" onClick={() => navigate('/cart')}>
						Checkout
					</CButton>
				</div>
			)}
		</div>
	)
}
